import { render } from "./LoadingOverlay.vue?vue&type=template&id=29c4f17f&ts=true"
import script from "./LoadingOverlay.vue?vue&type=script&lang=ts"
export * from "./LoadingOverlay.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cretzler/source/Contributr-v2/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__